import { render, staticRenderFns } from "./connector-data.vue?vue&type=template&id=47aa6d74&scoped=true"
import script from "./connector-data.vue?vue&type=script&lang=js"
export * from "./connector-data.vue?vue&type=script&lang=js"
import style0 from "./connector-data.vue?vue&type=style&index=0&id=47aa6d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa6d74",
  null
  
)

export default component.exports